import React from "react";
import numeral from "numeral";
import TimeHelper from "util/TimeHelper";
class CounterRate extends React.Component {
  constructor(props) {
    super(props);
    this._checkPrevMetric = () => this.state.prevMetric && this.state.prevMetric.count !== void 0 && this.state.prevTs;
    this._placeholder = () => {
      if (this.props.hideOnZero) {
        return null;
      }
      return /* @__PURE__ */ React.createElement("span", null, this._prefix(), "Calculating...");
    };
    this._prefix = () => {
      if (this.props.prefix) {
        return `${this.props.prefix} `;
      }
      return null;
    };
    this._suffix = () => {
      if (this.props.suffix) {
        return ` ${this.props.suffix}`;
      }
      return null;
    };
    this.state = {
      prevMetric: null,
      prevTs: null,
      nowTs: TimeHelper.nowInSeconds()
    };
  }
  UNSAFE_componentWillReceiveProps() {
    this.setState({
      prevMetric: this.props.metric,
      prevTs: this.state.nowTs,
      nowTs: TimeHelper.nowInSeconds()
    });
  }
  render() {
    if (!(this.props.metric && this.props.metric.count !== void 0)) {
      if (this.props.hideOnMissing) {
        return null;
      }
      if (!this._checkPrevMetric()) {
        return this._placeholder();
      }
    }
    const { count } = this.props.metric;
    let rate = null;
    if (this._checkPrevMetric()) {
      const rateNum = (count - this.state.prevMetric.count) / (this.state.nowTs - this.state.prevTs);
      rate = /* @__PURE__ */ React.createElement("span", { key: "rate", className: "number-format" }, this._prefix(), numeral(rateNum).format("0,0"), this._suffix());
    } else {
      return this._placeholder();
    }
    if (this.props.hideOnMissing && !rate) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("span", null, rate, this.props.showTotal && /* @__PURE__ */ React.createElement("span", { key: "absolute", className: "number-format" }, " ", "(", numeral(count).format("0"), " total)"));
  }
}
CounterRate.defaultProps = {
  showTotal: false,
  prefix: null,
  suffix: "per second",
  hideOnZero: false,
  hideOnMissing: false,
  metric: void 0
};
export default CounterRate;
